import { COUNTRY_CODES } from "../constants/COUNTRY_CODES";

export const getCountryCodeNumeric = (code) => {
  if (!code) return "+91";
  let cleanCode = String(code).trim().toUpperCase();
  // Remove common separators
  cleanCode = cleanCode.split(/[—\-\s]/)[0];
  console.log("getCountryCodeNumeric input:", cleanCode);
  // If already numeric format, return as-is
  if (cleanCode.startsWith('+') || /^\d+$/.test(cleanCode)) {
    return cleanCode.startsWith('+') ? cleanCode : '+' + cleanCode;
  }
  // Direct ISO2 lookup map for common codes
  const isoMap = {
    "NZ": "+64","US": "+1","GB": "+44","UK": "+44","CA": "+1","AU": "+61","IN": "+91","DE": "+49","FR": "+33","IT": "+39","ES": "+34",
    "NL": "+31","SE": "+46","NO": "+47","DK": "+45","FI": "+358","CH": "+41","JP": "+81","CN": "+86","PK": "+92","BD": "+880"
  };
  // First try direct ISO lookup
  if (isoMap[cleanCode]) {
    console.log("Found direct ISO match:", cleanCode, "->", isoMap[cleanCode]);
    return isoMap[cleanCode];
  }
  // Fallback: COUNTRY_CODES search by partial country name match
  const match = COUNTRY_CODES.find(({country}) => 
    country.toUpperCase().includes(cleanCode)
  );
  if (match) {
    console.log("Found COUNTRY_CODES partial match:", cleanCode, "in", match.country, "->", match.country_code);
    return match.country_code;
  }
  console.log("No match found for:", cleanCode, "- returning original");
  return cleanCode;
};

